import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import HCaptcha from "@hcaptcha/react-hcaptcha";

const validationSchema = Yup.object().shape({
    firstName: Yup.string().required().min(2).label("First name"),
    lastName: Yup.string().label("Last name"),
    email: Yup.string().required().email().label("Email"),
    phoneNumber: Yup.number().min(10).label("Phone"),
    message: Yup.string().required().min(50).max(2000).label("Message"),
    hCapthcaToken: Yup.string()
        .nullable()
        .required("This is hCaptcha for human testing.")
        .label("hCaptcha"),
});

export default function Contacts() {
    const [isCaptchaExpired, setIsCaptchaExpired] = useState(false);
    // const captchaRef = useRef(null);

    useEffect(() => {
        if (isCaptchaExpired) {
            formik.setFieldValue("hCapthcaToken", null);
        }
    }, [isCaptchaExpired]);

    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            message: "",
            hCapthcaToken: "",
        },
        onSubmit: (values) => {
            alert(JSON.stringify(values, null, 2));
        },
        validationSchema: validationSchema,
        validateOnChange: true,
    });

    const handleVerificationSuccess = (token) => {
        formik.setFieldValue("hCapthcaToken", token);
        if (token) setIsCaptchaExpired(false);
    };

    return (
        <main className="contacts-container m-auto  py-3">
            <div className="py-3" align="center">
                <h1>Contact us</h1>
                <p className="lead">
                    We’d love to hear from you. For general inquiries, submit
                    the form below.
                </p>
            </div>
            <form className="row g-3 " onSubmit={formik.handleSubmit}>
                <div className="col-md-6">
                    <label htmlFor="firstName" className="form-label">
                        First Name
                    </label>
                    <input
                        id="firstName"
                        name="firstName"
                        type="text"
                        className={`form-control ${
                            formik.touched.firstName &&
                            formik.errors.firstName &&
                            "is-invalid"
                        }`}
                        onChange={formik.handleChange("firstName")}
                        value={formik.values.firstName}
                    />
                    {formik.touched.firstName && formik.errors.firstName && (
                        <div className="invalid-feedback">
                            {formik.errors.firstName}
                        </div>
                    )}
                </div>
                <div className="col-md-6">
                    <label htmlFor="lastName" className="form-label">
                        Last Name
                    </label>
                    <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        className="form-control"
                        onChange={formik.handleChange("lastName")}
                        value={formik.values.lastName}
                    />
                </div>

                <div className="col-md-8">
                    <label htmlFor="emailInfo" className="form-label">
                        Email
                    </label>
                    <input
                        id="emailInfo"
                        type="email"
                        className={`form-control ${
                            formik.touched.email &&
                            formik.errors.email &&
                            "is-invalid"
                        }`}
                        placeholder="name@example.com"
                        onChange={formik.handleChange("email")}
                        value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <div className="invalid-feedback">
                            {formik.errors.email}
                        </div>
                    )}
                </div>
                <div className="col-md-4">
                    <label htmlFor="phoneNumber" className="form-label">
                        Phone Number
                    </label>
                    <input
                        type="tel"
                        inputMode="numeric"
                        className="form-control"
                        id="phoneNumber"
                        placeholder=""
                        onChange={formik.handleChange("phoneNumber")}
                    />
                </div>
                <div className="col-md-12">
                    <label htmlFor="message" className="form-label">
                        Message
                    </label>
                    <textarea
                        className={`form-control ${
                            formik.touched.message &&
                            formik.errors.message &&
                            "is-invalid"
                        }`}
                        id="message"
                        rows="3"
                        onChange={formik.handleChange("message")}
                    ></textarea>
                    {formik.touched.message && formik.errors.message && (
                        <div className="invalid-feedback">
                            {formik.errors.message}
                        </div>
                    )}
                </div>
                <div className="col-md-12">
                    <HCaptcha
                        // ref={captchaRef}
                        sitekey="8d147cae-36a3-40e9-a9c5-6f5742ce5219"
                        onVerify={(token) => handleVerificationSuccess(token)}
                        onExpire={() => setIsCaptchaExpired(true)}
                    />
                    <input
                        type="hidden"
                        className={`form-control ${
                            (formik.errors.hCapthcaToken ||
                                formik.values.hCapthcaToken == null) &&
                            "is-invalid"
                        }`}
                        value={formik.values.hCapthcaToken}
                    />
                    {formik.errors.hCapthcaToken &&
                    formik.values.hCapthcaToken != null ? (
                        <div className="invalid-feedback">
                            {formik.errors.hCapthcaToken}
                        </div>
                    ) : (
                        formik.values.hCapthcaToken == null && (
                            <div className="invalid-feedback">
                                The hCaptcha for human testing has expired.
                            </div>
                        )
                    )}
                </div>
                <div className="col-md-12">
                    <button type="submit" className="btn btn-dark">
                        Submit
                    </button>
                </div>
            </form>
        </main>
    );
}
